import { Component, Inject } from '@angular/core';
import { ASSETS_API_URL } from '@app/app.constants';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@app/auth/authentication.service';
import { CredentialsService } from '@shared/services/web/credentials.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { SideNavService } from '@shared/services/web/side-nav.service';
import { filter } from 'rxjs';
import { FilterPropertiesDataService } from '@shared/services/web/filter-properties.data.service';
import { SignInModalComponent } from '@app/security/modals/sign-in-modal/sign-in-modal.component';
import { LoginModalComponent } from '@app/security/modals/login-modal/login-modal.component';
import { ActionsService } from '@app/@shared/services/web/actions.service';
import { InvestCarouselResponse } from '@app/@shared/model/invest.model';
import { WeCallYouComponent } from '@app/@shared/components/we-call-you/we-call-you.component';
import { ScrollService } from '@app/@core/scroll.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public picturesServer = ASSETS_API_URL;
  menuHidden = true;
  toggleActive = false;
  public flagAreaPrivada = false;
  public snapshotUrl = '';
  public language = '';

  showSliderInvest = false;
  showSliderSell = false;
  showSliderHowItWorks = false;
  private menuCloseTimer: ReturnType<typeof setTimeout> | null = null;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private sideNavService: SideNavService,
    private authenticationService: AuthenticationService,
    public credentialsService: CredentialsService,
    public translateService: TranslateService,
    public filterPropertiesDataService: FilterPropertiesDataService,
    private dialog: MatDialog,
    private actionsService: ActionsService,
    private scrollService: ScrollService
  ) {}

  ngOnInit() {
    this.language = this.translateService.currentLang;
    this.flagAreaPrivada = this.router.url.includes('tablero-de-usuario');
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd | any) => {
        this.snapshotUrl = event.url;
        event.url.includes('tablero-de-usuario')
          ? (this.flagAreaPrivada = true)
          : (this.flagAreaPrivada = false);
      });
  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }

  async logout() {
    (await this.authenticationService.logout()).subscribe(() => {
      this.router.navigate(['/'], { replaceUrl: true }).then(() => {
        this.scrollService.scrollToTopImmediate();
      });
    });
  }
  getNavigateToUrl(path: string): string {
    if (path.includes('invertir') && this.router.url.includes('invertir')) {
      return '';
    } else {
      const customCreateUrl = `/${this.translateService.currentLang}/${path}`;
      return customCreateUrl;
    }
  }
  goNavigateToUrl(path: string): string | void {
    const customLang = this.translateService.currentLang;
    if (path === 'invertir') {
      if (
        !this.router.url.includes('invertir/propiedad') &&
        (this.router.url.includes('invertir') ||
          this.router.url.includes('invertir?'))
      ) {
        return '';
      } else {
        sessionStorage.removeItem('search');
        const customCreateUrl = `/${customLang}/${path}`;
        this.router.navigate([customCreateUrl]).then(() => {
          this.scrollService.scrollToTopImmediate();
        });
      }
    } else {
      const customCreateUrl = `/${customLang}/${path}`;
      this.router.navigate([customCreateUrl]).then(() => {
        this.scrollService.scrollToTopImmediate();
      });
    }
  }
  navigateToUrl(path: string): void {
    const customCreateUrl = `/${this.translateService.currentLang}/${path}`;
    let queryParams = '';
    if (path === 'invertir') {
      this.filterPropertiesDataService.putFiltersProperties(null);
    }
    if (path === 'ingresar') {
      queryParams = this.snapshotUrl;
    }
    if (queryParams !== '') {
      this.router.navigate([customCreateUrl], {
        queryParams: { redirect: this.snapshotUrl },
      }).then(() => {
        this.scrollService.scrollToTopImmediate();
      });
    } else {
      this.router.navigate([customCreateUrl]).then(() => {
        this.scrollService.scrollToTopImmediate();
      });
    }
  }
  goToBlog(): void {
    this.document.location.href = 'https://blog.inviertispro.com';
  }

  toogleSide() {
    this.toggleActive = !this.toggleActive;
    if (!this.flagAreaPrivada) {
      this.sideNavService.toggle();
    } else {
      this.sideNavService.toggleLogedIn();
    }
  }

  openCallModal() {
    this.dialog.open(WeCallYouComponent, {
      maxWidth: '95vw',
      panelClass: 'noPadding',
    });
  }

  openSignInModal() {
    this.dialog.open(SignInModalComponent, {
      maxWidth: '95vw',
      panelClass: 'icon-logo-modal',
      id: 'sign-in-modal-header',
    });
  }

  openLoginModal() {
    this.dialog.open(LoginModalComponent, {
      maxWidth: '95vw',
      panelClass: 'icon-logo-modal',
    });
  }

  onCardSelected(card: InvestCarouselResponse) {
    this.showSliderInvest = false;
    this.actionsService.investCarousel$.next(card);
  }
  onClearTooltip() {
    this.cancelMenuClose();
    this.showSliderInvest = false;
    this.showSliderSell = false;
    this.showSliderHowItWorks = false;
  }

  openMenu(menu: 'invest' | 'sell' | 'howItWorks') {
    this.cancelMenuClose();
    this.showSliderInvest = menu === 'invest';
    this.showSliderSell = menu === 'sell';
    this.showSliderHowItWorks = menu === 'howItWorks';
  }

  /**
   * Al salir del botón o del panel se cierra el desplegable, con una pequeña
   * espera para poder bajar del botón al panel sin que se cierre en el camino.
   */
  scheduleMenuClose() {
    this.cancelMenuClose();
    this.menuCloseTimer = setTimeout(() => this.onClearTooltip(), 250);
  }

  cancelMenuClose() {
    if (this.menuCloseTimer) {
      clearTimeout(this.menuCloseTimer);
      this.menuCloseTimer = null;
    }
  }
}
